﻿import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Route, Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/catch';

// APP 
import { SiteContact } from '../../viewmodel'
import { EntityAdded } from '../../viewmodel'
import { LookupService } from '../../services/lookup.service';
import { EntityService } from '../../services/entity.service';
import { SharedService } from '../../services/shared.service';

@Component({
    selector: 'app-addcontacts',
    templateUrl: './editcontact.component.html',
    providers: [EntityService]
})
export class EditContactComponent implements OnInit {
    title: string = 'Update Contact';
    contactForm: FormGroup;
    public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    public extensionMask = [/\d/, /\d/, /\d/, /\d/];
    public noSpaceAtBeginning = /^[^-\s]/;   

    pageError: any = [];
    pageSuccess: any = [];
    submitted: boolean = false;
    error: string;
    projectId: number = 0;
    entityId: number=0;
    type: string;
    contact: any;
    devTeamContact: any;
    contacts: Array<any>;
    companies: Array<any>;
    companyName: string;
    partyRoleName: string;
    entityAdded: any;
    partyId: number; 
    partyStagingId: number;
    attrDisabled: any = null;   //'disabled'  or null for enable

    constructor(private router: Router
        , private frmBuilder: FormBuilder
        , private activeRoute: ActivatedRoute
        , private lookupService: LookupService
        , private entityService: EntityService
        , private sharedService: SharedService) {

        this.contact = new SiteContact();
        this.entityAdded = new EntityAdded();
    }

    ngOnInit() {  
 
        let ids = this.sharedService.getJsonData("id");
        if (ids != null) {
            if (ids.projectId != null) {
                this.contact.projectId = this.projectId = ids.projectId;
            }
        }
        if (this.projectId <= 0)
            this.sharedService.navigateHome();

        let ecParams = this.sharedService.getData('entitycontactParams');
        if (ecParams != null) {           
            let params = JSON.parse(ecParams);
            this.contact.entityId = this.contact.MIHProjectDevTeamID = this.entityId = params.entitycontactParams.entityId; 
            this.contact.projectDevTeamContactId = params.entitycontactParams.projectDevTeamContactId;
            this.contact.projectBldgDevTeamContactId = params.entitycontactParams.projectBldgDevTeamContactId;
            this.contact.commContactId = params.entitycontactParams.commContactId;
            this.contact.partyId = this.partyId = params.entitycontactParams.partyId; 
            this.contact.partyStagingId = this.partyStagingId = params.entitycontactParams.partyStagingId;              
            this.companyName = params.entitycontactParams.companyName;
            this.partyRoleName = params.entitycontactParams.partyRoleName; 
        }      
        if (this.entityId <= 0) 
            this.sharedService.navigateSummary();
       
        this.contactForm = this.frmBuilder.group({

            fName: [null, [Validators.required, Validators.pattern(this.noSpaceAtBeginning), Validators.maxLength(30)]],
            lName: [null, [Validators.required, Validators.pattern(this.noSpaceAtBeginning), Validators.maxLength(30)]],
            primaryContact: [],
            email: [null, [Validators.required, Validators.maxLength(100), Validators.email]],
            companyPhone: [null, [Validators.required, Validators.pattern(/^\([1-9]\d{2}\)\s\d{3}-\d{4}|[1-9]\d{9}$/)]],
            phoneExt: [],
            partyName: [],
        });

        // Check for update     
        if (this.contact.entityId != null && this.contact.commContactId > 0) {
            this.entityService.GetMIHProjectDevTeamContactByMIHProjectDevTeamContactID(this.contact.projectDevTeamContactId)
                .subscribe(
                successResp => {
                    if (!successResp.Success)
                        this.showError(successResp.StatusMessage);
                    else if (successResp.Result != null) {
                        this.devTeamContact = successResp.Result;

                        if (this.devTeamContact != null)
                            this.populateExistingData(this.devTeamContact[0]);
                    }
                },
                error => {
                    this.showError(error.ExceptionMessage)
                });
        }

    }

    populateExistingData(data) {
        this.contact.partyId = this.partyId;  
        this.contact.partyStgId = this.partyStagingId;    

        if (this.contact.partyId > 0) {
            this.entityAdded.IsStageEntry = false;
            this.entityAdded.PartySeqNo = this.contact.partyId;
        }
        else {
            this.entityAdded.IsStageEntry = true;
            this.entityAdded.PartySeqNo = this.contact.partyStgId;
        }
        this.entityAdded.MIHProjectDevTeamID = this.entityId;

        this.contact.commContactId = data.CommContactID;
        this.contact.fName = data.ContactFirstName;
        this.contact.lName = data.ContactLastName;
        this.contact.email = data.ContactEmail;
        this.contact.isStageEntry = data.isStageEntry;
        this.contact.companyPhone = data.ContactPhone;
        this.contact.phoneExt = data.ContactPhoneExtension;
        this.contact.comContactTelconId = data.ContactTelecomID; 

        if (data.PrimaryContactFlag == 'Y')
        {
            this.contact.primaryContact = true;
            this.attrDisabled = 'disabled';
        }
        else
            this.contact.primaryContact = false;       
    }

    getContacts(entityAdded) {
        this.entityService.getContacts(entityAdded)
            .subscribe(
            successResp => {
                if (!successResp.Success)
                    this.showError(successResp.StatusMessage);
                else if (successResp.Result != null) {
                    if (successResp.Result.ContactDetails != null && successResp.Result.ContactDetails.length > 0) {
                        this.contacts = successResp.Result.ContactDetails;
                        this.contact.partyid = successResp.Result.PartySeqNo;  // assign party id & isStageEntry
                        this.contact.isStageEntry = successResp.Result.isStageEntry;

                    }
                    else {
                        this.contacts = [];
                    }
                }
            },
            error => {
                this.showError(error.ExceptionMessage)
            })
    }

    saveContact(btnType): any {
        this.submitted = true;        
        let cont = this.contactForm.getRawValue();
        if (!this.contactForm.valid)
            return;
        
        if (this.contact.fName != null && this.contact.fName.trim() == '') 
            this.contact.fName = '';
        if (this.contact.lName != null && this.contact.lName.trim() == '') 
            this.contact.lName = '';

        if (this.contact.fName == '' || this.contact.lName == '')
            return;
               
        this.contact.fName = this.contact.fName.trim();
        this.contact.lName = this.contact.lName.trim();
        this.contact.projectId = this.projectId;
        this.contact.entityId = this.entityId;
        this.contact.dbApplicationId = 84;
        this.contact.isStageEntry = false;
        if (this.contact.partyId == 0) {
            this.contact.partyId = this.contact.partyStagingId;
            this.contact.isStageEntry = true;
        }
    
        this.contact.isStageEntry = this.entityAdded.IsStageEntry;  
        if (this.contact.phoneExt != null && this.contact.phoneExt != '') {
            this.contact.phoneExt = this.contact.phoneExt.replace(/_+/g, '');
        }        

        // Remove masking
        if (this.contact.companyPhone) {
            this.contact.companyPhone = this.contact.companyPhone.replace(/\D/g, '');
        }
        
        this.entityService.saveEntityContact(this.contact)
            .subscribe(
            success => {
                if (!success.Success) {	
                    if (success.StatusMessage != null && success.StatusMessage.indexOf('Contact already exists') !== -1) {
                        this.showErrorAlert(success.StatusMessage);
                    }
                    else {
                        this.showError(success.StatusMessage);
                    }				
				}
                else {                
                    this.showSuccess('Development contact successfully saved.');
					
                    if (btnType == 'UPDATE') {
                        this.sharedService.removeData("entitycontactParams");
                        this.sharedService.navigateSummary();
                    }
                    else if (btnType == 'ANOTHER') {
                        this.resetForm();

                    }
                }
            },
            error => {
                this.showError(error.ExceptionMessage)
            })
    }

    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.showError(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }

    showErrorAlert(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(msg);
        this.sharedService.processError(msg);
    }

    showSuccess(msg) {
        this.pageSuccess = []; this.pageError = [];
        this.pageSuccess.push(msg);
        this.sharedService.scroll();
    }

    home() {
        this.sharedService.navigateHome();
    }

    back() {
        this.sharedService.navigateSummary();
    }

    resetForm() {
        this.contact = [];
        this.contact

    }
}